import { memo } from 'react';

import { Heading, Text } from '@/components/core';
import { TriggerHeader } from '@/components/flow';
import { ZapierLogo } from '@/components/logos';

export type ZapierTriggerNodeContentProps = {
  agentId: string;
  actionId: string;
};

const IZapierTriggerNodeContent = ({ agentId, actionId }: ZapierTriggerNodeContentProps) => {
  return (
    <>
      <div className="flex items-center gap-2 border-b border-gray-200 pb-2">
        <TriggerHeader agentId={agentId} actionId={actionId}>
          <ZapierLogo size="lg" />
          <Heading size="lg">Import from Zapier</Heading>
        </TriggerHeader>
      </div>

      <div className="flex flex-col gap-2 pt-2">
        <Text>When a document is submitted from a Zap.</Text>
      </div>
    </>
  );
};

export const ZapierTriggerNodeContent = memo(IZapierTriggerNodeContent) as typeof IZapierTriggerNodeContent;
